import { Alert, AlertTitle, Typography } from "@mui/material";
import PropTypes from "prop-types";

/**
 * راهنمای تخصیص مسئول پیگیری (کارشناس سولارنت) در کارتابل بررسی اولیه.
 */
const AssignmentOperatorHelp = ({
  showAssignmentUi,
  featureChecked,
  canClaimRequests = false,
  currentUserKind = null,
  currentUserRoleName = null,
  hasClaimableRow,
  compact = false,
}) => {
  if (!featureChecked) return null;

  if (showAssignmentUi && !canClaimRequests) {
    return (
      <Alert severity="warning" sx={{ mb: 2 }}>
        <AlertTitle>دریافت درخواست فقط برای کارشناس سولارنت</AlertTitle>
        <Typography variant="body2" component="div">
          نوع کاربر ذخیره‌شده در دیتابیس:{" "}
          <strong>{currentUserKind ?? "نامشخص"}</strong> (باید{" "}
          <strong>۳</strong> = کارشناس سولارنت باشد).
          {currentUserRoleName ? (
            <>
              <br />
              گروه کاربری شما: <strong>{currentUserRoleName}</strong>
            </>
          ) : null}
          <br />
          اگر در فرم کاربر «کارشناسان سولارنت» را می‌بینید ولی اینجا عدد ۲ است،
          یک‌بار در <strong>مدیریت کاربران → ویرایش کاربر</strong> دکمه «ویرایش»
          را بزنید (همگام‌سازی نوع کاربر با گروه کاربری)، سپس از حساب خارج
          شوید و دوباره وارد شوید. مدیریت فقط <strong>آزادسازی</strong> دارد.
        </Typography>
      </Alert>
    );
  }

  if (!showAssignmentUi) {
    return (
      <Alert severity="warning" sx={{ mb: 2 }}>
        <AlertTitle>تخصیص مسئول پیگیری غیرفعال است</AlertTitle>
        <Typography variant="body2" component="div">
          در سرور API مقدار{" "}
          <strong>RequestAssignment:Enabled</strong> باید <strong>true</strong> باشد و
          سرویس یک‌بار Restart شود. پس از آن فیلتر «وضعیت مسئولیت» و دکمه «دریافت
          درخواست» نمایش داده می‌شود.
        </Typography>
      </Alert>
    );
  }

  if (!hasClaimableRow && !compact) {
    return (
      <Alert severity="info" sx={{ mb: 2 }}>
        <AlertTitle>چطور مسئول پیگیری مشخص می‌شود؟</AlertTitle>
        <Typography variant="body2" component="div">
          مسئول پیگیری از لیست کارشناسان انتخاب نمی‌شود؛{" "}
          <strong>همان کارشناسی که دکمه «دریافت درخواست» را می‌زند</strong> مسئول
          می‌شود.
          <br />
          اگر دکمه را نمی‌بینید: با حساب <strong>کارشناس سولارنت</strong> وارد شوید،
          فیلتر «بدون مسئول»، وضعیت <strong>بررسی نشده</strong>. آیکن سبز «دریافت
          درخواست» (شخص +) اول ستون عملیات است.
          <br />
          مسئول را در ستون «مسئول» می‌بینید (بدون مسئول / شما / نام کارشناس).
          <br />
          <em>ناظر پروژه</em> فیلد جداگانه‌ای در فرم ویرایش است و با مسئول پیگیری
          فرق دارد.
        </Typography>
      </Alert>
    );
  }

  if (compact) {
    return (
      <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 1 }}>
        برای تخصیص خودتان به‌عنوان مسئول پیگیری، دکمه «دریافت درخواست» را بزنید.
        انتخاب کارشناس دیگر از این صفحه امکان‌پذیر نیست.
      </Typography>
    );
  }

  return (
    <Alert severity="success" sx={{ mb: 2 }}>
      <AlertTitle>دریافت درخواست = مسئول پیگیری شما</AlertTitle>
      <Typography variant="body2">
        روی آیکن/دکمه سبز «دریافت درخواست» در لیست یا مودال «مشاهده اطلاعات» کلیک
        کنید. پس از آن در ستون مسئول «شما» نمایش داده می‌شود.
      </Typography>
    </Alert>
  );
};

AssignmentOperatorHelp.propTypes = {
  showAssignmentUi: PropTypes.bool,
  featureChecked: PropTypes.bool,
  canClaimRequests: PropTypes.bool,
  currentUserKind: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  currentUserRoleName: PropTypes.string,
  hasClaimableRow: PropTypes.bool,
  compact: PropTypes.bool,
};

export default AssignmentOperatorHelp;
